import axios from "axios";

const instance = axios.create({
  // baseURL: "http://localhost:5001/v1/api/"
  baseURL: "https://api.steelcitypress.in/v1/api/"
});


const getheaders = ()=>{
  const token = localStorage.getItem("token");
  if(token){
    return {
    "Content-Type": "application/json",
    "Authorization":`Bearer ${token}`
  }
  }else{
     return {
    "Content-Type": "application/json",
  }
}
};


// ✅ REQUEST INTERCEPTOR (Attach JWT Token Automatically)
instance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers = getheaders();
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// ✅ RESPONSE INTERCEPTOR (Optional - Handle 401 Auto Logout)
instance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem("token");
      window.location.href = "/login"; // redirect to login
    }
    return Promise.reject(error);
  }
);

export default instance;